import { footerData } from '@/mocks/homeData';

export default function Footer() {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="w-full bg-background-800 text-background-200">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-2">
            <a
              href="#hero"
              onClick={(e) => handleClick(e, '#hero')}
              className="text-xl md:text-2xl font-heading font-bold text-background-50 mb-4 block cursor-pointer"
            >
              2828电影网
            </a>
            <p className="text-sm text-background-400 leading-relaxed max-w-md mb-6">
              {footerData.description}
            </p>
            <div className="flex items-center gap-3">
              <a href="#contact" onClick={(e) => handleClick(e, '#contact')} className="w-9 h-9 rounded-full bg-background-700 hover:bg-primary-600 flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-mail-line text-sm text-background-200"></i>
              </a>
              <span className="w-9 h-9 rounded-full bg-background-700 flex items-center justify-center cursor-default">
                <i className="ri-wechat-line text-sm text-background-200"></i>
              </span>
              <span className="w-9 h-9 rounded-full bg-background-700 flex items-center justify-center cursor-default">
                <i className="ri-weibo-line text-sm text-background-200"></i>
              </span>
            </div>
          </div>

          {footerData.sections.map((section) => (
            <div key={section.title}>
              <h4 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">
                {section.title}
              </h4>
              <ul className="space-y-2.5">
                {section.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      onClick={(e) => handleClick(e, link.href)}
                      className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-8 border-t border-background-700/50">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-1">
              <span className="text-xs text-background-500">
                {footerData.partnersTitle}
              </span>
              <span className="text-xs text-background-600">
                更多合作伙伴即将入驻
              </span>
            </div>
            <p className="text-xs text-background-500 whitespace-nowrap">
              {footerData.copyright}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}